import React from 'react';
import { useNavigate } from 'react-router-dom';
import './error.css';

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <div className="errorpage">
      <div className="errorcard">

        <h1>404</h1>
        <h2>Page Not Found</h2>

        <p>
          The page you are looking for does not exist or has been moved.
        </p>

        <div className="erroractions">

          <button onClick={() => navigate('/')}>
            Go Home
          </button>

          <button onClick={() => navigate(-1)}>
            Go Back
          </button>

        </div>

      </div>
    </div>
  );
};

export default ErrorPage;